export const DICT: Record<string, Record<string, string>> = {
    SOMETHING_WENT_WRONG: {
        ru: 'Что-то пошло не так',
        en: 'Something went wrong',
    },
    INTERNAL_SERVER_ERROR: {
        ru: 'Внутренняя ошибка сервера',
        en: 'Internal server error',
    },
    COOKIE_TEXT: {
        ru: 'Продолжая использовать сайт, вы соглашаетесь со сбором файлов cookie для работы сайта и его улучшения',
        en: 'By continuing to use the site, you agree to the collection of cookies for the operation of the site and its improvement',
    },
    ACCOUNT: {
        ru: 'Личный кабинет',
        en: 'Account',
    },
    SEARCH: {
        ru: 'Поиск',
        en: 'Search',
    },
    SEARCH_FIND: {
        ru: 'Найти',
        en: 'Find',
    },
    CLOSE: {
        ru: 'Закрыть',
        en: 'Close',
    },
    SEARCH_INPUT_TEXT: {
        ru: 'Что вас интересует?',
        en: 'What are you interested in?',
    },
    MAIN: {
        ru: 'Главная',
        en: 'Main',
    },
    ALL: {
        ru: 'Все',
        en: 'All',
    },
    NOT_FOUND: {
        ru: 'К сожалению, по вашему запросу ничего не найдено',
        en: 'Unfortunately, nothing was found for your request',
    },
    FILL_FIELD: {
        ru: 'Заполните поле',
        en: 'Fill in the field',
    },
    ATTACH_FILE: {
        ru: 'Прикрепите файл',
        en: 'Please attach a file',
    },
    INVALIDATED_FILE_SIZE: {
        ru: 'Размер файла не должен превышать 256 MB',
        en: 'File size must not exceed 256 MB',
    },
    FILL_CHECKED: {
        ru: 'Это поле обязательно',
        en: 'This field is required',
    },
    MAX_CHAR_COUNT: {
        ru: 'Максимум 100 символов',
        en: 'Maximum 100 characters',
    },
    MIN_CHAR_COUNT: {
        ru: 'Минимум 30 символов',
        en: 'Minimum 30 Characters',
    },
    INVALID_PHONE_NUMBER: {
        ru: 'Некорректный номер телефона',
        en: 'Invalid phone number',
    },
    INVALID_EMAIL: {
        ru: 'Введите корректный адрес эл. почты',
        en: 'Enter a valid email address',
    },
    TIN: {
        ru: 'Выберите компанию из списка, всплывающего при вводе названия компании или ИНН',
        en: 'Select a company from the list that appears when entering the company name or TIN.',
    },

    ERROR_OCCURRED: {
        ru: 'Произошла ошибка.',
        en: 'An error occurred.',
    },
    RESEND: {
        ru: 'Отправить снова',
        en: 'Resend',
    },
    SUPPORT_SERVICE: {
        ru: 'Служба поддержки TNF',
        en: 'TNF Support Service',
    },

    APPLY_POPUP_MESSAGE: {
        ru: ' <p class="text-l">Спасибо, форма отправлена </p> <br/> Благодарим Вас за время и включенность в формирование программы TNF. <br/><br/> Ваше предложение передано программному комитету. Мы обязательно свяжемся с Вами по указанному e-mail, чтобы обсудить дальнейшие шаги, — вне зависимости от того, войдет ли идея в финальную повестку. <br/><br/> Лучшие инициативы будут включены в официальную программу форума.',
        en: '<p class="text-l">Thank you, the form has been sent </p> <br/> Thank you for your time and involvement in the formation of the TNF program. <br/><br/> Your proposal has been submitted to the program committee. We will definitely contact you by the specified e-mail to discuss further steps, regardless of whether the idea is included in the final agenda. <br/> The best initiatives will be included in the official program of the forum.',
    },
    TARIFF_DESCRIPTION: {
        ru: 'с учетом НДС',
        en: 'including VAT',
    },
    TARIFF_DESCRIPTION_WITHOUT_VAT: {
        ru: 'Без учета НДС 22%',
        en: 'Excluding VAT 22%',
    },
    FORUM_DAYS: {
        ru: 'Дни форума:',
        en: 'Forum days:',
    },
    PROGRAM_FORMAT: {
        ru: 'Формат программы:',
        en: 'Program format:',
    },
    ALL_DAYS: {
        ru: 'Все дни',
        en: 'All days',
    },
    PARTICIPATION_FORMAT: {
        ru: 'Формат участия',
        en: 'Format of participation',
    },
};
